import {
  defaultReportsPage,
  myReportsPage,
  buildReportsPage,
} from '../configs/reports-v4';
import { allScopes, alwaysDisplayed } from '../configs/shared';

export const reports = {
  id: 'reports-v4',
  name: _TL_('Reporting'),
  description: _TL_('View performance data with instant reports or by creating custom reports.'),
  route: 'reports-v4',
  fixedRoute: 'reports-v4',
  scope: allScopes,
  campaignTypes: alwaysDisplayed,
  children: [
    defaultReportsPage,
    myReportsPage,
    buildReportsPage,
  ],
};
